module.exports = __webpack_public_path__ + "assets/images/boundaries/keys-four-new-smc/key-3-2020.svg?v=f315321a";